import React from 'react';
import StatCard from '../common/StatCard';
import InlineError from '../common/InlineError';

/**
 * Platform Analytics KPI Cards (PDF Page 6)
 * 6 non-clickable, visually static KPI cards focusing purely on consumer mobile app engagement.
 */
const PlatformAnalyticsCards = ({ stats, loading, error, onRetry }) => {
    if (error) {
        return (
            <InlineError 
                message="Unable to load platform analytics. Please check your network connection or try again."
                onRetry={onRetry}
            />
        );
    }

    return (
        <div className="row row-cols-xxl-6 row-cols-lg-3 row-cols-md-2 row-cols-1 g-3">
            {/* 1. Total Mobile App Users */}
            <div className="col">
                <StatCard 
                    title="Total Mobile App Users"
                    value={loading ? '...' : (stats.total_mobile_users || 0).toLocaleString()}
                    icon="solar:users-group-two-rounded-bold"
                    iconBg="var(--hs-primary-50)"
                    iconColor="var(--hs-primary-600)"
                    helperText="Registered mobile app users"
                />
            </div>

            {/* 2. Total Saves */}
            <div className="col">
                <StatCard 
                    title="Total Saves"
                    value={loading ? '...' : (stats.total_saves || 0).toLocaleString()}
                    icon="solar:bookmark-bold"
                    iconBg="rgba(239, 68, 68, 0.1)"
                    iconColor="#ef4444"
                    helperText="Combined bookmarks"
                />
            </div>

            {/* 3. Venue Saves */}
            <div className="col">
                <StatCard 
                    title="Venue Saves"
                    value={loading ? '...' : (stats.venue_saves || 0).toLocaleString()}
                    icon="solar:shop-2-bold"
                    iconBg="var(--hs-info-bg)"
                    iconColor="var(--hs-info)"
                    helperText="Venues bookmarked"
                />
            </div>

            {/* 4. Content Saves */}
            <div className="col">
                <StatCard 
                    title="Content Saves"
                    value={loading ? '...' : (stats.content_saves || 0).toLocaleString()}
                    icon="solar:document-text-bold"
                    iconBg="var(--hs-warning-bg)"
                    iconColor="var(--hs-warning)"
                    helperText="Blogs & articles saved"
                />
            </div>

            {/* 5. Total Reviews */}
            <div className="col">
                <StatCard 
                    title="Total Reviews"
                    value={loading ? '...' : (stats.total_reviews || 0).toLocaleString()}
                    icon="solar:star-bold"
                    iconBg="var(--hs-warning-bg)"
                    iconColor="var(--hs-warning)"
                    helperText="Customer venue ratings"
                />
            </div>

            {/* 6. Unique Customers */}
            <div className="col">
                <StatCard 
                    title="Unique Customers"
                    value={loading ? '...' : (stats.unique_customers || 0).toLocaleString()}
                    icon="solar:user-check-bold"
                    iconBg="var(--hs-success-bg)"
                    iconColor="var(--hs-success)"
                    helperText="Active engaged users"
                />
            </div>
        </div>
    );
};

export default PlatformAnalyticsCards;
